import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import dayjs from 'dayjs';

// Format Display for Job duration
// start = hh:mm:ss
// end = hh:mm:ss
// pause = number
export const formatJobDurationDisplay = (
  start: string,
  end: string,
  pause: string,
): string => {
  return `${dayjs(start, 'HH:mm:ss').format('HH:mm')} - ${dayjs(
    end,
    'HH:mm:ss',
  ).format('HH:mm')} ${pause ? `(${pause} minuten pauze)` : ''}`;
};

// Format date to locale Netherlands date
export const formatDateToLocaleNetherlands = (date: string): string => {
  return new Date(date)
    .toLocaleString('nl-NL', {
      day: '2-digit',
      month: 'long',
      timeZone: 'Europe/Amsterdam',
      weekday: 'long',
      year: 'numeric',
    })
    .toString()
    .replace(/(^\w{1})|(\s+\w{1})/g, (letter) => letter.toLowerCase());
};

// Format date to locale Netherlands date short
export const formatDateNetherlandsShort = (date: string): string => {
  return new Date(date)
    .toLocaleString('nl-NL', {
      day: '2-digit',
      month: 'short',
      timeZone: 'Europe/Amsterdam',
      year: 'numeric',
    })
    .toString()
    .replace(/(^\w{1})|(\s+\w{1})/g, (letter) => letter.toLowerCase());
};

// Format time (4.5) to display time (hh:mm)
export const formatTime = (time: number): string => {
  const [hours, mins] = time.toString().split('.');
  let minsToFormat = mins;
  if (parseInt(minsToFormat, 10) === 0 || !mins) {
    minsToFormat = '00';
  } else {
    const min = 60 * parseFloat(`0.${mins}`);
    minsToFormat = min.toString().padStart(2, '0');
  }
  return `${hours}:${minsToFormat}`;
};

// Format rates for compensation
interface formatRateReturnType {
  displayText: string;
  useHighlight: boolean;
}

export const formatRates = (
  maxRate: number,
  maxRateIncl: number,
  maxRateExempt: number,
  actualRate: number,
  actualRateIncl: number,
  actualRateExempt: number,
  vatExempt: boolean,
): formatRateReturnType => {
  if (vatExempt) {
    if (maxRateExempt !== null && actualRateExempt > maxRateExempt) {
      return {
        displayText: `${maxRateExempt.toFixed(2)} (btw vrij)`,
        useHighlight: true,
      };
    }
    return {
      displayText: `${actualRateExempt.toFixed(2)} (btw vrij)`,
      useHighlight: false,
    };
  }
  if (maxRate !== null && actualRate > maxRate) {
    return {
      displayText: `${maxRate.toFixed(2)} (excl) / ${maxRateIncl.toFixed(
        2,
      )} (incl)`,
      useHighlight: true,
    };
  }
  return {
    displayText: `${actualRate.toFixed(2)} (excl) / ${actualRateIncl.toFixed(
      2,
    )} (incl)`,
    useHighlight: false,
  };
};
